class TimezoneService {
  get currentTimezone() {
    const user = window.$nuxt.$store.getters['members/me'];
    return user.currentOrganization?.addresses.getItem(0)?.timezone
      || Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  currentShortTimezone(date= new Date()) {
    if (!this.currentTimezone) return undefined;

    return this.getShortTimeZone(this.currentTimezone, date);
  }

  formatDate(date, timeZone = undefined, format = 'compact') {
    let options = {};
    if (format === 'date') {
      options = {
        timeZone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      };
    } else if (format === 'full') {
      options = {
        timeZone,
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      };
    } else {
      options = {
        timeZone,
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      };
    }

    return this.getDateTimeFormat(options).format(date);
  }

  getDateTimeFormat(options) {
    const locale = window.$nuxt.$LanguageService.currentLanguageInfo.code.replace('_', '-');
    return new Intl.DateTimeFormat(locale, options);
  }

  getShortTimeZone(timeZone, date = new Date()) {
    const options = {
      timeZone,
      timeZoneName: 'short',
    };

    return this.getDateTimeFormat(options)
      .formatToParts(date)
      .find(({ type }) => type === 'timeZoneName')
      ?.value;
  }
}

// Inject plugin in instance
export default (context, inject) => {
  inject('TimezoneService', new TimezoneService());
}
